import { useQuery } from '@tanstack/react-query'

import { QUERY_KEY, TANSTACK_QUERY_DEFAULT_GC_TIME, TANSTACK_QUERY_DEFAULT_STALE_TIME } from '@/lib/constants'
import { getFacebookLoginStatus } from '@/services/facebook-service'

export function getFacebookLoginStatusQuery() {
  return {
    queryKey: [QUERY_KEY.FACEBOOK, 'login-status'] as const,
    queryFn: async (): Promise<boolean> => {
      const { data, ok } = await getFacebookLoginStatus()

      if (!ok && data?.statusCode === 403) {
        return false
      }

      if (!ok) {
        throw new Error('Failed to fetch Facebook login status')
      }
      
      return !!data?.loggedIn
    },
    staleTime: TANSTACK_QUERY_DEFAULT_STALE_TIME,
    gcTime: TANSTACK_QUERY_DEFAULT_GC_TIME,
    refetchOnWindowFocus: false,
    retry: 0,
  }
}

export const useFacebookLoginStatusQuery = () => {
  return useQuery(getFacebookLoginStatusQuery())
}
